import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu", "toggle", "backdrop"]

  connect() {
    // Bind ESC key handler
    this.boundHandleEsc = this.handleEsc.bind(this)
    document.addEventListener("keydown", this.boundHandleEsc)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEsc)
    this.close()
  }

  toggle() {
    if (this.menuTarget.classList.contains("is-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.add("is-open")
    this.toggleTarget.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.menuTarget.classList.remove("is-open")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  handleEsc(event) {
    if (event.key === "Escape" && this.menuTarget.classList.contains("is-open")) {
      this.close()
    }
  }

  // Close menu when clicking a navigation link
  closeOnNavigate() {
    this.close()
  }
}
